// extracted by mini-css-extract-plugin
export default {"addCategorySection":"style_addCategorySection__T0huZ","actionsSection":"style_actionsSection__hpRR6","formSection":"style_formSection__R2GBZ"};